<template>
  <!-- 应收款明细表 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
   <!-- 列表 -->
    <div>
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <el-button @click="setup_list">审核</el-button>
           <el-button @click="updates">反审核</el-button>
           <el-button @click="updates_list">全部审核</el-button>
           <el-button @click="setups_list">全部反审核</el-button>
           <el-button @click="dels" v-if="ERP.isPermission(4004012)">删除</el-button>
           <el-button @click="delslist" v-if="ERP.isPermission(4004012)">全部删除</el-button>
           <el-button @click="check_list">导出对账</el-button>
         </div>
         <div class="cdj_div" style="display: flex;">
           <div style="margin-top: 4px;">
             查询条件-
             <span v-if="search">{{search}}</span><span v-else>所有房产</span>
             <!-- <span style="color: red;margin-left: 10px;" v-if="loadings == 1">加载中...</span> -->
           </div>
           <div style="width: 400px;margin-left: 30px;">
               <el-autocomplete
               v-model="house_name"
               size="mini"
               style="width: 100%;"
               :fetch-suggestions="querySearchAsync"
               placeholder="可搜索房产"
               clearable
               @select="handleSelect"
             ></el-autocomplete>
           </div>
           <div style="margin-top: 4px;">
             <span style="color: red;margin-left: 10px;" v-if="loadings == 1">加载中...</span>
           </div>
         </div>
         <div class="cdj_table">
           <div class="cdj_display">
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">收费项目</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.chargeItem_name_id"
                       style="width: 100%"
                       clearable
                       @change="chargeItem_names"
                       size="mini"
                       placeholder="收费项目">
                       <el-option
                         v-for="item in chargeitem_1"
                         :key="item.id"
                         :label="item.chargeItem_name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">客户名称</div>
                 <div class="cdj_el-input">
                     <el-input size="mini" v-model="data.name"></el-input>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">计费周期</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-date-picker size="mini" v-model="startDate" type="date" placeholder="开始时间"></el-date-picker>
                   <span class="cdj_text_data">至</span>
                   <el-date-picker size="mini" v-model="endDate" type="date" placeholder="结束时间"></el-date-picker>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">是否缴清</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-checkbox-group v-model="data.state" style="margin-top: 3.5px;">
                      <el-checkbox label="1" name="type">未缴款</el-checkbox>
                      <el-checkbox label="2" name="type">部分缴款</el-checkbox>
                      <el-checkbox label="3" name="type">已缴款</el-checkbox>
                    </el-checkbox-group>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">生成日期</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-date-picker size="mini" v-model="startGenerate_date" type="datetime" default-time="00:00:00" placeholder="开始时间"></el-date-picker>
                   <span class="cdj_text_data">至</span>
                   <el-date-picker size="mini" v-model="endGenerate_date" type="datetime" default-time="23:59:59" placeholder="结束时间"></el-date-picker>
                 </div>
               </div>
             </div>

            <!-- 右 -->
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">收费标准</div>
                   <el-select
                       v-model="data.chargeitemID"
                       class="cdj_el-input"
                       size="mini"
                       clearable
                       placeholder="收费标准">
                       <el-option
                         v-for="item in charge"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">审核标记</div>
                 <div class="cdj_el-input el-date-pickers" style="margin-top: 5px;">
                    <el-radio v-model="data.IsCheck" label="1">未审核</el-radio>
                    <el-radio v-model="data.IsCheck" label="2">已审核</el-radio>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">应收日期</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-date-picker size="mini" v-model="startShould_charge_date" type="date" placeholder="开始时间"></el-date-picker>
                   <span class="cdj_text_data">至</span>
                   <el-date-picker size="mini" v-model="endShould_charge_date" type="date" placeholder="结束时间"></el-date-picker>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">排除挂账</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-checkbox-group v-model="data.chargeitem_type_id" style="margin-top: 3.5px;">
                      <el-checkbox label="" name="type" disabled></el-checkbox>
                    </el-checkbox-group>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">审核日期</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-date-picker size="mini" v-model="startIsCheckDate" type="date" placeholder="开始时间"></el-date-picker>
                   <span class="cdj_text_data">至</span>
                   <el-date-picker size="mini" v-model="endIsCheckDate" type="date" placeholder="结束时间"></el-date-picker>
                 </div>
               </div>
             </div>
           </div>
        </div>
       <el-tabs v-model="activeName" @tab-click="handleClick">
         <el-tab-pane label="应收明细" name="first">
           <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
             <el-table-column type="selection" width="55"></el-table-column>
             <el-table-column prop="id" label="ID" width="80"></el-table-column>
             <el-table-column prop="h_name" label="客户名称" width="100"></el-table-column>
             <el-table-column prop="h_name_date" label="房产" width="200"></el-table-column>
             <el-table-column prop="charge_name" label="收费标准" width="170"></el-table-column>
             <el-table-column  label="计费周期" width="140">
               <template slot-scope="scope">
                 {{scope.row.startDate}}-{{scope.row.endDate}}
               </template>
             </el-table-column>
             <el-table-column prop="should_charge_date" label="应收日期" width="80"></el-table-column>
             <el-table-column prop="xsc_Amount" label="面积/用量" width="80"></el-table-column>
             <el-table-column prop="xsc_Price" label="单价" width="60"></el-table-column>
             <el-table-column prop="charge_after" label="应收金额" width="80"></el-table-column>
             <el-table-column prop="chargePay_after" label="实际应收" width="80"></el-table-column>
             <el-table-column prop="remark" label="备注" width="60"></el-table-column>
             <el-table-column prop="a_update_name" label="修改" width="50"></el-table-column>
             <el-table-column prop="IsCheck" label="审核" width="50"></el-table-column>
             <el-table-column prop="IsCheckName" label="审核人" width="80"></el-table-column>
             <el-table-column prop="state" label="是否缴清" width="80"></el-table-column>
             <el-table-column prop="generate_date" label="生成时间" width="150"></el-table-column>
<!--             <el-table-column label="操作" width="60">
               <template slot-scope="scope">
                 <div style="display: flex;">
                   <div style="color: blue;cursor: pointer;width:80px" @click="selectOrder(scope.row.id)">查看</div>
                 </div>
               </template>
             </el-table-column>-->
           </el-table>
           <div class="pages" v-if="desserts">
             <Page :total="total" :page-size="page" @on-change="change"  show-total />
           </div>
         </el-tab-pane>

         <el-tab-pane label="应收汇总" name="second">
           <el-table ref="multipleTable" :data="routineSum" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
             <el-table-column type="selection" width="55"></el-table-column>
             <el-table-column prop="name" label="收费项目" width="150"></el-table-column>
             <el-table-column  label="计费周期" show-overflow-tooltip>
               <template slot-scope="scope">
                 {{scope.row.startDate}}-{{scope.row.endDate}}
               </template>
             </el-table-column>
             <el-table-column prop="endDate" label="应收日期" width="120"></el-table-column>
             <el-table-column prop="xsc_Amount" label="面积/用量" width="120"></el-table-column>
             <el-table-column prop="chargePay_after" label="应收金额" width="120"></el-table-column>
             <el-table-column prop="discount_after" label="减免金额" width="120"></el-table-column>
             <el-table-column prop="charge_after" label="实际应收金额" width="120"></el-table-column>
<!--             <el-table-column prop="money" label="实际应收金额" width="120"></el-table-column>-->
           </el-table>
         </el-tab-pane>
         <el-tab-pane label="查看日记" name="third">
           <el-table ref="multipleTable" :data="dessertsLog" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
             <el-table-column type="selection" width="55"></el-table-column>
             <el-table-column prop="name" label="处理结果"></el-table-column>
             <el-table-column prop="endDate" label="发生时间" width="150"></el-table-column>
           </el-table>
           <!-- <div class="pages" v-if="dessertsLog">
             <Page :total="total" :page-size="page" @on-change="change"  show-total />
           </div> -->
         </el-tab-pane>
       </el-tabs>
      </div>
    </div>

    <!-- 查看 -->
    <Modal
      v-model="addmodel"
      width="950"
      title="应收款详细信息"
      okText="关闭">
      <div>
          <div class="cdj_div">应收款明细信息，房产：{{data.homeName}}</div>
           <div class="cdj_table">
              <div class="cdj_display">
                <!-- 左 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>房产</div>
                    <div class="cdj_el-input">
                        <el-select
                            style="width:100%"
                            v-model="houesmoney.house_id"
                            class="search"
                            size="mini"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="可搜索房产/客户姓名"
                            :loading="loading">
                            <el-option
                              v-for="item in selectList"
                              :key="item.id"
                              :label="item.house"
                              :value="item.id">
                            </el-option>
                          </el-select>
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">联系人</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.name" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>收费项目</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.xsc_ChargeItemID_id" style="width: 100%" clearable size="mini" placeholder="收费项目">
                        <el-option v-for="item in chargeitem_2" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收日期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:100%" v-model="houesmoney.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>单价</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_Price"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.charge"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">已缴金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.PaidChargeSum"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">减免类型</div>
                    <div class="cdj_el-input">
                        <el-select v-model="houesmoney.discountType" style="width: 100%" clearable size="mini" placeholder="减免类型">
                          <el-option v-for="item in discount_type" :key="item.number" :label="item.name" :value="item.number"></el-option>
                        </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">面积</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_Amount"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">备注</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.remark"></el-input>
                    </div>
                  </div>
                </div>
                <!-- 右 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>客户名称</div>
                    <div class="cdj_el-input" style="display:flex;">
                        <el-input size="mini" v-model="houesmoney.h_name"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">联系电话</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.phoen" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>收费标准</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.charge_id" style="width: 100%" clearable size="mini" placeholder="收费标准">
                        <el-option v-for="item in charges1" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>计费周期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.startDate" type="date" placeholder="开始时间"></el-date-picker>
                      <span style="margin-top: 3.5px;">至</span>
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.endDate" type="date" placeholder="结束时间"></el-date-picker>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>承担比例</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.proportion"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>计费标志</div>
                    <div class="cdj_el-input" style="margin-top: 3.5px;">
                      <el-radio v-model="houesmoney.sign" label="1">是</el-radio>
                      <el-radio style="margin-left: -20px;" v-model="houesmoney.sign" label="2">否</el-radio>
                      （是否按照计费时间自动计算)
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">挂账金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.account"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">减免金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.discount"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.chargePay"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收标志</div>
                    <div class="cdj_el-input" style="margin-top: 3.5px;">
                      <el-radio v-model="houesmoney.chargePaySign" label="1">普通应收</el-radio>
                      <el-radio style="margin-left: -20px;" v-model="houesmoney.chargePaySign" label="2">调整应收</el-radio>
                    </div>
                  </div>
                </div>
              </div>
           </div>
      </div>
    </Modal>

    <!-- 全部审核 -->
    <Modal
      v-model="calculate"
      width="700"
      title="全部审核"
      okText="全部审核"
      :loading="loadingModal"
      @on-ok="calculateMoneyAdd"
      @on-cancel="tops">
      <div>
           <div class="cdj_div">审核当前条件查询到的数据</div>
           <div class="cdj_table" >
               <div class="cdj_left" style="width: 100%;">
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">进度</div>
                   <div class="cdj_el-input">
                     <el-progress style="margin-top: 5px;" :text-inside="true" :stroke-width="20" :percentage="timecount"></el-progress>
                   </div>
                 </div>
                 <div style="margin-top: 7px;">
                   全部审核<br>
                   1、开始审核后，可关闭窗口，后台会运行审核;<br>
                   2、或等待审核完成;<br>
                 </div>
               </div>
          </div>
      </div>
    </Modal>
    <!-- 全部反审核 -->
    <Modal
      v-model="calculate1"
      width="700"
      title="全部反审核"
      okText="全部反审核"
      :loading="loadingModal"
      @on-ok="calculateMoneyAdd1"
      @on-cancel="tops">
      <div>
           <div class="cdj_div">审核当前条件查询到的数据</div>
           <div class="cdj_table" >
               <div class="cdj_left" style="width: 100%;">
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">进度</div>
                   <div class="cdj_el-input">
                     <el-progress style="margin-top: 5px;" :text-inside="true" :stroke-width="20" :percentage="timecount"></el-progress>
                   </div>
                 </div>
                 <div style="margin-top: 7px;">
                   全部审核<br>
                   1、开始审核后，可关闭窗口，后台会运行审核;<br>
                   2、或等待审核完成;<br>
                 </div>
               </div>
          </div>
      </div>
    </Modal>

</div>


</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
export default {
  name: "FormsOweMoney",
  data () {
    return {
      house_name:"",
      calculate1:false,
      calculate:false,
      loadingModal:true,
      addmodel:false,
      activeName: 'first',
      checkeds:'',
      checked:[],
      startDate:'',
      endDate:'',
      startGenerate_date:'',
      endGenerate_date:'',
      startShould_charge_date:'',
      endShould_charge_date:'',
      startIsCheckDate:'',
      endIsCheckDate:'',
      chargeitem:[],
      loading:false,
      loadings:2,
      desserts: '',
      total:0,
      page:12,
      search:'',
      data:{
        pid:'',
        name:'',
        state:[],
        IsCheck:'1',
        house_id:'',
        homeName:'',
        startDate:'',
        endDate:'',
        startGenerate_date:'',
        endGenerate_date:'',
        startShould_charge_date:'',
        endShould_charge_date:'',
        startIsCheckDate:'',
        endIsCheckDate:'',
        chargeitemID:[],
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:2,
      },
      chargeitem_type:[],
      chargeitem_1:[],
      chargeitem_2:[],
      charge:[],
      homeName:'',
      house:'',
      houesmoney:{
        id:'',
        house_id:'',
        h_name:'',
        name:'',
        phoen:'',
        xsc_ChargeItemID_id:'',
        charge_id:'',
        should_charge_date:'',
        xsc_Price:'',
        proportion:'1',
        sign:'2',
        account:'0.00',
        chargePaySign:'1',
        charge:'',
        PaidChargeSum:'0.00',
        discount:'0.00',
        discountType:'',
        xsc_Amount:'',
        remark:'',
        startDate:'',
        endDate:'',
        chargePay:'',
      },
      routineSum:[],
      selectList:[],
      charges1:[],
      developer:[],
      discount_type:[],
      dessertsLog:'',
      timecount:0,
      timer:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    //减免类型
    this.$myhttp.get('admin/common/discount_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.discount_type = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //远程搜索方式
    querySearchAsync(query, cb) {
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name?house_name='+query,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            let value = [];
            this.selectList.map(req=>{
              value.push({'value':req.house})
            })
            cb(value)
        });
      }
    },
    //搜索选中
    handleSelect(item) {
      this.data.pid = '';
      this.data.homeName = item.value;
      this.search = item.value;
      this.$myhttp.get("admin/MoneyCheck/house?house="+item.value,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        if(backdata.data.code == 200){
          let datas = backdata.data.data;
          this.data.pid = datas[0].erp_pindex_id;
          this.change(1);
        }
      });
    },
    //查看
    selectOrder(id){
      this.$myhttp.get("admin/RoutineExpense/getUpdate?id="+id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          //console.log(backdata.data.data);
          this.houesmoney = backdata.data.data.order[0];
          this.selectList = backdata.data.data.house;
          this.charges1 = backdata.data.data.charge;
          this.developer = backdata.data.data.customer;
          this.addmodel = true;
      });
    },
    //标签
    handleClick(tab, event) {
      console.log(tab.name);
      if(tab.name == 'second'){
        this.moneySum();
      }
      if(tab.name == 'third'){

      }
    },
    //应收汇总
    moneySum(){
      this.dates();
      //ERP.showLoading()
      this.$myhttp.post('admin/MoneyCheck/orderRoutineSum',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          if(backdata.data.code == 200){
            this.routineSum = data;
          }else{
            this.routineSum = [];
            //this.$Message.success(backdata.data.message);
          }
          //ERP.hideLoading()
      });
    },
    //点击费用类型
    chargeitem_types(){
      this.$myhttp.get("admin/RoomSetUp/chargeitem_type?chargeitem_type="+this.data.chargeitem_type_id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_1 = backdata.data.data;
      });
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.data.chargeitemID = '';
          this.charge = backdata.data.data;
      });
    },

    handleSelectionChange(val) {
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
      let order = val;
      order.map((req,index)=>{
        if(index == 0){
          this.checked.checked0 = req.id;
        }
        if(index == 1){
          this.checked.checked1 = req.id;
        }
        if(index == 2){
          this.checked.checked2 = req.id;
        }
        if(index == 3){
          this.checked.checked3 = req.id;
        }
        if(index == 4){
          this.checked.checked4 = req.id;
        }
        if(index == 5){
          this.checked.checked5 = req.id;
        }
        if(index == 6){
          this.checked.checked6 = req.id;
        }
        if(index == 7){
          this.checked.checked7 = req.id;
        }
        if(index == 8){
          this.checked.checked8 = req.id;
        }
        if(index == 9){
          this.checked.checked9 = req.id;
        }
        if(index == 10){
          this.checked.checked10 = req.id;
        }
        if(index == 11){
          this.checked.checked11 = req.id;
        }
      })
    },
    //获得当前多少页,分页
    change(e){
      this.dates();
      this.emdtime();
      // ERP.showLoading()
      this.loadings = 1;
      this.data.page = e;
      this.$myhttp.post('admin/MoneyCheck/index',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loadings = 2;
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          // ERP.hideLoading()
      });
      this.checkeds = false;
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
    },
    //时间转换
    dates(){
      //计费周期
      this.data.startDate = '';
      this.data.endDate = '';
      if(this.startDate != null && this.startDate != ''){
        let d = this.startDate;//开始时间
        let startDate = new Date(d).getTime()/1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if(this.endDate != null && this.endDate != ''){
        let d = this.endDate;//开始时间
        let endDate = new Date(d).getTime()/1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
      //生成日期
      this.data.startGenerate_date = '';
      this.data.endGenerate_date = '';
      if(this.startGenerate_date != null && this.startGenerate_date != ''){
        let d = this.startGenerate_date;//开始时间
        let startGenerate_date = new Date(d).getTime()/1000;
        startGenerate_date = Number(startGenerate_date).toFixed(0);
        this.data.startGenerate_date = startGenerate_date;
      }
      if(this.endGenerate_date != null && this.endGenerate_date != ''){
        let d = this.endGenerate_date;//开始时间
        let endGenerate_date = new Date(d).getTime()/1000;
        endGenerate_date = Number(endGenerate_date).toFixed(0);
        this.data.endGenerate_date = endGenerate_date;
      }
      //应收日期
      this.data.startShould_charge_date = '';
      this.data.endShould_charge_date = '';
      if(this.startShould_charge_date != null && this.startShould_charge_date != ''){
        let d = this.startShould_charge_date;//开始时间
        let startShould_charge_date = new Date(d).getTime()/1000;
        startShould_charge_date = Number(startShould_charge_date).toFixed(0);
        this.data.startShould_charge_date = startShould_charge_date;
      }
      if(this.endShould_charge_date != null && this.endShould_charge_date != ''){
        let d = this.endShould_charge_date;//开始时间
        let endShould_charge_date = new Date(d).getTime()/1000;
        endShould_charge_date = Number(endShould_charge_date).toFixed(0);
        this.data.endShould_charge_date = endShould_charge_date;
      }
      //审核日期
      this.data.startIsCheckDate = '';
      this.data.endIsCheckDate = '';
      if(this.startIsCheckDate != null && this.startIsCheckDate != ''){
        let d = this.startIsCheckDate;//开始时间
        let startIsCheckDate = new Date(d).getTime()/1000;
        startIsCheckDate = Number(startIsCheckDate).toFixed(0);
        this.data.startIsCheckDate = startIsCheckDate;
      }
      if(this.endIsCheckDate != null && this.endIsCheckDate != ''){
        let d = this.endIsCheckDate;//开始时间
        let endIsCheckDate = new Date(d).getTime()/1000;
        endIsCheckDate = Number(endIsCheckDate).toFixed(0);
        this.data.endIsCheckDate = endIsCheckDate;
      }

    },

    //搜索
    searchs(){
      this.change(1);
      this.moneySum();
      this.emdtime();
    },
    //收费项项目（按项目查）
    p_chargeitem_name(){
      this.$myhttp.get('admin/common/p_chargeitem_name?pid='+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_1 = backdata.data.data;
          this.chargeitem_2 = backdata.data.data;
      });
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      // this.change(1);
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.p_chargeitem_name();
      this.change(1);
      this.moneySum();
    },
    //删除
    dels(){
      if(this.data.IsCheck == 2){
        this.$Message.error("不能删除已审核账单");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/MoneyCheck/dels',this.checked,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code==200){
              this.$Message.success(backdata.data.message);
              this.change(1);
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }).catch(() => {

      });
    },
    //全部删除
    delslist(){
      if(this.data.IsCheck == 2){
        this.$Message.error("不能删除已审核账单");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/MoneyCheck/delslist',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code==200){
              this.$Message.success(backdata.data.message);
              this.change(1);
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }).catch(() => {

      });

    },

    //审核
    setup_list(){
      if(this.data.IsCheck == 2){
        this.$Message.error("不能审核已审核账单");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/MoneyCheck/setup_list',this.checked,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code==200){
              this.$Message.success(backdata.data.message);
              this.change(1);
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }).catch(() => {

      });
    },
    //反审核
    updates(){
      if(this.data.IsCheck == 1){
        this.$Message.error("不能反审核未审核账单");
        return false;
      }
      if(this.data.pid == ''){
        this.$Message.error("项目不能为空，点击左边树选择项目");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/MoneyCheck/updates?pid='+this.data.pid,this.checked,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code==200){
              this.$Message.success(backdata.data.message);
              this.change(1);
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }).catch(() => {

      });
    },
    //全部审核
    updates_list(){
      if(this.data.pid == ''){
        this.$Message.error("点击左边树选择房产");
        return false;
      }
      if(this.data.IsCheck == 2){
        this.$Message.error("不能审核已审核账单");
        return false;
      }
      this.timecount = 0;
      this.calculate = true;
      this.emdtime();
      //直接请求全部审核
      // this.$confirm('确定操作吗, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   ERP.showLoading()
      //   this.$myhttp.post('admin/MoneyCheck/updates_list',this.data,{
      //     'Content-Type': 'application/x-www-form-urlencoded'
      //     }).then(backdata=>{ // 异步执行成功后
      //       ERP.hideLoading()
      //       if(backdata.data.code==200){
      //         this.$Message.success(backdata.data.message);
      //         this.change(1);
      //       }else{
      //         this.$Message.error(backdata.data.message);
      //       }
      //   });
      // }).catch(() => {

      // });
    },
    calculateMoneyAdd(){
      this.data.type = 1;
      this.$myhttp.post('admin/MoneyCheck/updates_list_sql',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            if(backdata.data.code==200){
              // this.change(1);
              // this.timecount = 100;
              // this.loadingModals();
              if(backdata.data.message == '已存在全部审核，执行中'){
                this.times(backdata.data.id)
                this.$Message.success(backdata.data.message);
              }else{
                this.times(backdata.data.id)
              }
            }else{
              this.loadingModals();
              this.$Message.error(backdata.data.message);
              this.calculate = false;
            }
      });
    },
    calculateMoneyAdd1(){
      this.data.type = 2;
      this.$myhttp.post('admin/MoneyCheck/updates_list_sql',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            if(backdata.data.code==200){
              // this.change(1);
              // this.timecount = 100;
              // this.loadingModals();
              if(backdata.data.message == '已存在全部反审核，执行中'){
                this.times(backdata.data.id)
                this.$Message.success(backdata.data.message);
              }else{
                this.times(backdata.data.id)
              }
            }else{
              this.loadingModals();
              this.$Message.error(backdata.data.message);
              this.calculate = false;
            }
      });
    },
    //进度分析
    changelog(id){
      let data = {'id':id,'types':1};
      this.$myhttp.post('admin/MoneyCheck/updates_list_sql',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.timecount = backdata.data.timecount;
          if(backdata.data.timecount == 100){
            this.change(1);
            this.loadingModals();
            this.emdtime();
          }
      });
    },
    //定时器
    times(id){
      let _this = this;
      let oen = 1;
      this.timer = setInterval(() => {
        _this.changelog(id);
        if(oen > 400){
          _this.emdtime();
        }
        oen++;
      }, 2000);
    },
    emdtime(){
      let _this = this;
      clearInterval(this.timer);
    },
    tops(){
       this.emdtime();
    },

    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10)
    },



    //全部反审核
    setups_list(){
      if(this.data.pid == ''){
        this.$Message.error("点击左边树选择房产");
        return false;
      }
      if(this.data.IsCheck == 1){
        this.$Message.error("不能反审核未审核账单");
        return false;
      }
      this.timecount = 0;
      this.calculate1 = true;
      this.emdtime();
      //直接请求全部反审核
      // this.$confirm('确定操作吗, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   ERP.showLoading()
      //   this.$myhttp.post('admin/MoneyCheck/setups_list',this.data,{
      //     'Content-Type': 'application/x-www-form-urlencoded'
      //     }).then(backdata=>{ // 异步执行成功后
      //       ERP.hideLoading()
      //       if(backdata.data.code==200){
      //         this.$Message.success(backdata.data.message);
      //         this.change(1);
      //       }else{
      //         this.$Message.error(backdata.data.message);
      //       }
      //   });
      // }).catch(() => {

      // });
    },
    //导出
    check_list(){
      this.dates();
      ERP.showLoading()
      this.data.page = 1;
      this.$myhttp.post('admin/MoneyCheck/excel',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          let data = backdata.data.data;
          if(backdata.data.code == 200){
            let url = this.$myhttp.defaults.baseURL
            window.open(url+data, '_blank');
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    }
  },
  watch:{

  },

  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/expense/MoneyCheck.vue